module.exports = __webpack_public_path__ + "img/LogoV2-White_ClearBknd.8996eb22.png";